import { PayloadAction } from '@reduxjs/toolkit';

import { TollState } from '../../types';

export const setActiveTollSection = (state: TollState, action: PayloadAction<TollState['activeTollSection']>) => {
  state.activeTollSection = action.payload;
};
